export const esTranslations = {
    email: "Correo electrónico",
    password: "Contraseña",
    write_your_email: "Escribe tu correo electróncio",
    write_your_password: "Escribe tu contraseña",
    login: "Iniciar sesión",
    user_login_bad_credentials: "El usuario no existe o las credenciales de acceso no son válidas.",
    go_home: "Ir a la página de inicio",
    profile: "Perfil",
    edit_profile: "Editar perfil",
    exit: "Salir",
    menu: "Menú",
    administration: "Administración",
    specialities: "Especialidades",
    modalities: "Modalidades",
    clubs: "Clubes",
    teams: "Equipos",
    team: "Equipo",
    seasons: "Temporadas",
    "Name": "Nombre",
    changed_at: "Última modificación",
    "Write to search": "Escribe lo que quieres buscar",
    search: "Buscar",
    new_speciality: "Nueva especialidad",
    "Delete": "Eliminar",
    delete_speciality: "ELiminar especialidad",
    delete_speciality_message: "La especialidad <strong>{{speciality_name}} ({{speciality_code}})</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    "Save": "Guardar",
    "Close": "Cerrar",
    actions: "Acciones",
    description: "Descripción",
    code: "Código",
    edit_speciality: "Editar especialidad",
    icon_upload_message: "Opcionalmente puedes cargar una imagen",
    single_image_warning: "Sólo se permiten cargar un archivos de tipo imagen. Elimina el archivo cargado para cargar uno diferente.",
    new_modality: "Nueva modalidad",
    speciality: "Especialidad",
    select_speciality: "- Seleccionar especialidad -",
    gender: "Sexo",
    select_gender: "- Seleccionar sexo -",
    man: "Hombre",
    woman: "Mujer",
    "Men": "Hombres",
    "Women": "Mujeres",
    "Mixt": "Mixto",
    distance: "Distancia",
    boat: "Embarcación",
    edit_modality: "Editar modalidad",
    delete_modality_message: "La modalidad <strong>{{modality_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    new_club: "Nuevo club",
    edit_club: "Editar club",
    delete_club: "Eliminar club",
    document_id: "NIF",
    date_foundation: "Fecha de fundación",
    region: "Provincia",
    city: "Municipio",
    website: "Página web",
    address: "Dirección postal",
    phone: "Teléfono",
    registry_num: "Número de registro",
    select_region: "- Selecciona una provincia -",
    logo: "Logotipo",
    delete_club_message: "El club <strong>{{club_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    new_season: "Nueva temporada",
    "Start date": "Fecha de inicio",
    "End date": "Fecha de fin",
    edit_season: "Editar temporada",
    "Delete season": "Elininar temporada",
    delete_season_message: "La temporada <strong>{{season_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    categories: "Categorías",
    new_category: "Nueva categoría",
    edit_category: "Editar categoría",
    age_start: "Edad mínima",
    age_end: "Edad máxima",
    start_age_warning: "Indicar una edad válida.",
    delete_category: "Elininar categoría",
    delete_category_message: "La categoría <strong>{{category_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    new_team: "Nuevo equipo",
    club: "Club",
    select_club: "- Selecciona un club",
    modality: "Modalidad",
    select_modality: "- Selecciona una modalidad -",
    category: "Categoría",
    select_category: "- Selecciona una categoría -",
    edit_team: "Editar equipo",
    delete_team: "Eliminar equipo",
    delete_team_message: "El equipo <strong>{{team_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    management: "Dirección",
    users: "Usuarios",
    new_user: "Nuevo usuario",
    first_name: "Nombre",
    last_name: "Apellidos",
    birthdate: "Fecha de nacimiento",
    role: "Rol",
    select_role: "- Seleccionar rol -",
    "Administrator": "Administrador",
    "Manager": "Directivo",
    "Coach": "Entrenador",
    "Athlete": "Deportista",
    edit_user: "Editar usuario",
    delete_user: "Eliminar usuario",
    delete_user_message: "El usuario <strong>{{user_name}} ({{user_email}})</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    my_space: "Mi espacio",
    athletes: "Deportistas",
    "Reports": "Informes",
    coach: "Entrenador",
    training_templates: "Plantillas de entreno",
    training_sessions: "Sesiones de entreno",
    athlete: "Deportista",
    disable_user: "Desactivar usuario",
    disable_user_message: "El usuario <strong>{{user_name}} ({{user_email}})</strong> será desactivado. Esto significa que ya no podrá acceder a la plataforma hasta que vuelva a ser activado. ¿Estás seguro de que quieres desactivarlo?",
    disable: "Desactivar",
    user_status_switch_label: "¿El usuario está activado?",
    disabled: "No activado",
    new_athlete: "Nuevo deportista",
    birth_city: "Ciudad de nacimiento",
    birth_region: "Provincia de nacimiento",
    birth_country: "País de nacimiento",
    country: "País",
    athlete_status_switch_label:  "¿El deportista está activado?",
    birth_place: "Lugar de nacimiento",
    residence_place: "Lugar de residencia",
    select_country: "- Seleccionar país -",
    avatar_upload_message: "Opcionalmente cargar foto del deportista",
    years: "Años",
    edit_athlete: "Editar deportista",
    team_athletes: "Deportistas del equipo",
    "Remove from team": "Eliminar del equipo",
    "Add to team": "Añadir al equipo",
    "Adding... ({{done}} of {{total}})": "Añadiendo... ({{done}} de {{total}})",
    "Removing... ({{done}} of {{total}})": "Eliminando... ({{done}} de {{total}})",
    "Back": "Volver",
    "No athletes available": "No hay deportistas disponibles",
    "Previous year": "Año anterior",
    "Next year": "Año siguiente",
    "Activity type": "Tipo de actividad",
    "All types": "Todas",
    "Total distance": "Distancia total",
    "Max Heart Rate": "Pulsaciones máx.",
    "Aerobic efficiency": "Eficiencia aeróbica",
    "Aerobic efficiency formula": "Velocidad media ÷ pulsaciones medias × 100. Más alto = más rápido al mismo pulso (mejor forma).",
    "Kayak": "Kayak",
    "Whitewater kayak": "Kayak aguas bravas",
    "Canoe": "Canoa",
    "Paddle surf": "Paddle surf",
    season: "Temporada",
    select_season: "- Seleccionar temporada -",
    select_athlete: "- Seleccionar deportista -",
    dorsal: "Dorsal",
    position: "Posición",
    athlete_measurements: "Mediciones del deportista",
    measurement_date: "Fecha de medición",
    weight_label: "Peso (gr)",
    height_label: "Altura (cm)",
    bmi_label: "IMC (kg/m²)",
    fm_label: "Grasa (kg/m²)",
    bm_label: "Masa (kg/m²)",
    "Table view": "Vista de tabla",
    "Card view": "Vista de tarjetas",
    "Select all": "Seleccionar todos",
    "Deselect all": "Deseleccionar todos",
    "Add performance": "Añadir rendimiento",
    "Add performance for": "Añadir rendimiento para",
    "Performance data added successfully for": "Datos de rendimiento añadidos correctamente para",
    "Some performance data could not be added. Please try again.": "Algunos datos de rendimiento no se pudieron añadir. Por favor, inténtalo de nuevo.",
    "Error adding performance data. Please try again.": "Error al añadir datos de rendimiento. Por favor, inténtalo de nuevo.",
    "Saving...": "Guardando...",
    "Age": "Edad",
    "Avatar": "Avatar",
    "Add performance data": "Añadir datos de rendimiento",
    "Save data": "Guardar datos",
    "No performance data to save": "No hay datos de rendimiento para guardar",
    "Performance data saved successfully": "Datos de rendimiento guardados correctamente",
    "Cancel": "Cancelar",
    "Accept": "Aceptar",
    "Settings": "Configuración",
    "Select setting to configure": "Selecciona la configuración",
    "- Select -": "- Seleccionar -",
    "Performance KPIs": "KPIs de rendimiento",
    "Performance KPIs Configuration": "Configuración de KPIs de rendimiento",
    "Define labels and units for each performance KPI": "Define etiquetas y unidades para cada KPI de rendimiento",
    "no_active_kpis_configured": "No hay KPIs activos configurados",
    "No performance data available": "No hay datos de rendimiento disponibles",
    "Select a KPI to display": "Selecciona un KPI para mostrar",
    "Select KPI": "Seleccionar KPI",
    "Year": "Año",
    "KPI": "KPI",
    "Label": "Etiqueta",
    "Unit": "Unidad",
    "e.g., Speed": "ej., Velocidad",
    "e.g., km/h": "ej., km/h",
    "e.g., Distance": "ej., Distancia",
    "e.g., meters": "ej., metros",
    "e.g., Power": "ej., Potencia",
    "e.g., watts": "ej., watts",
    "e.g., Heart Rate": "ej., Frecuencia cardíaca",
    "e.g., bpm": "ej., bpm",
    "Settings saved successfully": "Configuración guardada correctamente",
    "Error saving settings. Please try again.": "Error al guardar la configuración. Por favor, inténtalo de nuevo.",
    "Loading...": "Cargando...",
    "Loading settings...": "Cargando configuración...",
    "Performance Evolution": "Evolución del Rendimiento",
    "Value": "Valor",
    staff: "Personal",
    new_staff: "Nuevo miembro de la plantilla",
    edit_staff: "Editar miembro de la plantilla",
    staff_status_switch_label:  "¿El miembro de la plantilla está activado?",
    team_staff: "Miembros de la plantilla",
    select_staff: "- Seleccionar personal -",
    "User": "Usuario",
    notifications: "Notificaciones",
    wearables: "Wearables",
    select_team: "- Seleccionar equipo -",
    videos: "Videos",
    video_upload_message: "Carga un video",
    video_mandatory_alert: "Es necesario cargar un vídeo",
    edit_video: "Editar video",
    delete_video: "Eliminar video",
    delete_video_message: "El video <strong>{{video_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    training_session_tpls: "Plantillas de sesiones de entreno",
    new_training_session_tpl: "Nueva plantilla de sesión de entreno",
    edit_training_session_tpl: "Editar plantilla de sesión de entreno",
    new_training_session: "Nueva sesión de entreno",
    edit_training_session: "Editar sesión de entreno",
    goals: "Objetivos",
    phases: "Grupos de ejercicios",
    delete_training_session_tpl: "Eliminar plantilla de sesión de entreno",
    delete_training_session_tpl_message: "La plantilla de sesión de entreno <strong>{{training_session_tpl_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    new_training_session_phase_tpl: "Nuevo grupo de ejercicios",
    delete_training_session: "Eliminar sesión de entreno",
    delete_training_session_message: "La sesión de entreno <strong>{{training_session_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    new_training_session_phase: "Nueva grupo de ejercicios",
    recipients_training: "Athletas que lo realizarán",
    new_phase: "Nuevo grupo de ejercicios",
    training_session_no_recipients: "No hay deportistas asignados a esta sesión de entreno",
    add_athletes: "Añadir deportistas",
    select_option: "- Selecciona una opción -",
    add: "Añadir",
    reference_already_assigned: "Esta asignación ya existe",
    no_exercises_in_phase: "No se han definido ejercicios para este grupo",
    edit_training_session_phase_tpl: "Editar grupo de ejercicios",
    delete_training_session_phase_tpl: "Eliminar grupo de ejercicios",
    delete_training_session_phase_tpl_message: "El grupo de ejercicios <strong>{{training_session_tpl_phase_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    edit_training_session_phase: "Editar grupo de ejercicios",
    delete_training_session_phase: "Eliminar grupo de ejercicios",
    delete_training_session_phase_message: "El grupo de ejercicios <strong>{{training_session_phase_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    add_exercise: "Añadir ejercicio",
    new_training_session_exercise_tpl: "Nuevo ejercicio",
    delete_training_session_exercise_tpl: "Eliminar ejercicio",
    delete_training_session_exercise_tpl_message: "El ejercicio <strong>{{training_session_tpl_exercise_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    edit_training_session_exercise_tpl: "Editar ejercicio",
    new_training_session_exercise: "Nuevo ejercicio",
    delete_training_session_exercise: "Eliminar ejercicio",
    delete_training_session_exercise_message: "El ejercicio <strong>{{training_session_exercise_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    edit_training_session_exercise: "Editar ejercicio",
    no_videos_in_phase: "No se han asociado videos a este grupo",
    add_videos: "Añadir videos",
    video_selector: "Selector de videos",
    no_videos_in_excercise: "No se han asociado videos a este ejercicio",
    clone: "Duplicar",
    exercises: "Ejercicios",
    no_phases_message: "Ningún grupo de ejercicios definido",
    one_phase: "1 grupo de ejercicios",
    multiple_phases: "grupos de ejercicios",
    no_exercises_message: "Ningún ejercicio definido",
    one_exercise: "1 ejercicio",
    multiple_exercises: "ejercicios",
    zero_exercises: "0 ejercicios",
    date_part: "Fecha",
    time_part: "Hora",
    date_time: "Fecha y hora",
    message_template_source: "¿Cómo quieres empezar a diseñar la sesión de entrenamiento?",
    from_scratch: "Desde cero",
    from_template: "Usando una plantilla",
    select_template: "- Seleccionar plantilla -",
    no_date_planned: "Actividad no planificada",
    trainings: "Entrenamientos",
    trainings_maintenance: "Mantenimiento de Entrenamientos",
    search_by_type_description: "Buscar por tipo o descripción",
    "Content Distribution": "Distribución de los contenidos",
    "Number of sessions": "Num. sesiones",
    "Total sessions": "Sesiones totales",
    "Enter the total number of training sessions": "Introduce el número total de sesiones de entrenamiento",
    "Edit Content": "Editar Contenido",
    "Enter a numeric value or descriptive text": "Introduce un valor numérico o texto descriptivo",
    "Additional notes or comments": "Notas o comentarios adicionales",
    new_training: "Nuevo Entrenamiento",
    edit_training: "Editar Entrenamiento",
    delete_training: "Eliminar Entrenamiento",
    add_section: "Añadir Sección",
    section_name: "Nombre de Sección",
    section_color: "Color de Sección",
    edit_section: "Editar Sección",
    delete_section: "Eliminar Sección",
    delete_section_confirm: "¿Estás seguro de que quieres eliminar esta sección? Los entrenamientos no se eliminarán.",
    "Loading trainings...": "Cargando entrenamientos...",
    type: "Tipo",
    select_type: "- Seleccionar tipo -",
    aerobic: "Aeróbico",
    anaerobic: "Anaeróbico",
    strength: "Fuerza",
    technique: "Técnica",
    tactical: "Táctico",
    load: "Carga",
    comments: "Comentarios",
    values: "Valores",
    km: "KM",
    th: "TH",
    code_extra: "Código",
    note: "Nota",
    "Are you sure you want to delete this training?": "¿Estás seguro de que quieres eliminar este entrenamiento?",
    "Training cannot be deleted": "El entrenamiento no puede ser eliminado",
    "Error creating training": "Error al crear el entrenamiento",
    "Error updating training": "Error al actualizar el entrenamiento",
    "Error deleting training": "Error al eliminar el entrenamiento",
    "Please fill in all required fields": "Por favor, completa todos los campos obligatorios",
    competitions: "Competiciones",
    new_competition: "Nueva competición",
    date_description: "Descripción de la fecha",
    venue_name: "Nombre de la sede",
    venue_link: "Enlace a la sede",
    documents_upload_message: "Opcionalmente puees subir documentos",
    Documents: "Documentos",
    delete_competition: "Eliminar competición",
    delete_competition_message: "La competición <strong>{{competition_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    edit_competition: "Editar competición",
    passed_competitions: "Competiciones pasadas",
    upcoming_events: "Próximos eventos",
    "Races": "Pruebas",
    "Race list": "Lista de pruebas",
    "Add race": "Añadir prueba",
    "No races scheduled for this week": "No hay pruebas programadas para esta semana",
    "Edit race": "Editar prueba",
    "New race": "Nueva prueba",
    "e.g., National Championship": "ej., Campeonato Nacional",
    "Additional details about the race": "Detalles adicionales sobre la prueba",
    "Please enter a title for the race": "Por favor, introduce un título para la prueba",
    "Error saving race. Please try again.": "Error al guardar la prueba. Por favor, inténtalo de nuevo.",
    "Are you sure you want to delete this race?": "¿Estás seguro de que quieres eliminar esta prueba?",
    "Error deleting race. Please try again.": "Error al eliminar la prueba. Por favor, inténtalo de nuevo.",
    "to": "al",
    connection_expired: "La conexión ha caducado. Vuelve a autenticarte en la aplicación",
    welcome: "Bienvenido/a",
    forgot_password_question: "¿Has olvidado la contraseña?",
    reset_password: "Restablecer contraseña",
    rankings: "Rankings",
    color: "Color",
    management_2: "Gestión",
    birth: "Nacimiento",
    contact_info: "Datos de contacto",
    weight: "Peso",
    "Body Mass Index": "Índice de masa corporal",
    "Body Mass": "Masa corporal",
    "Fat mass": "Masa grasa",
    "Athletes ranking": "Ranking de deportistas",
    "Teams ranking": "Ranking de equipos",
    "Statistics": "Estadísticas",
    "Athletes statistics": "Estadísticas de deportistas",
    "Teams statistics": "Estadísticas de equipos",
    "Performance": "Rendimiento",
    delete_ats_message: "El deportista asignado a esta temporada y equipo se eliminará. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    "Yes": "Sí",
    "No": "No",
    athlete_team_seasons: "Temporadas y equipos",
    delete_sts_message: "El entrenador asignado a esta temporada y equipo se eliminará. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    staff_team_seasons: "Temporadas y equipos",
    new_video: "Nuevo video",
    "Check your credentials or ask your superior. Yo are not allowed to login now.": "Revisa tus datos de acceso o pregunta a tu responsable o persona de contacto para la aplicación. No tienes permisos para acceder a la aplicación en estos momentos.",
    "Athletes and teams": "Deportistas y equipos",
    "Coaches": "Entrenadores",
    "New coach": "Nuevo entrenador",
    "Edit coach": "Editar entrenador",
    "Delete coach": "Eliminar entrenador",
    "delete_coach_message": "El entrenador <strong>{{coach_name}}</strong> y todos los datos que dependen de este, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    "Competitions and events": "Competiciones y eventos",
    "Events": "Eventos",
    "Passed events": "Eventos pasados",
    "New event": "Nuevo evento",
    "Edit event": "Editar evento",
    "Delete event": "Eliminar evento",
    "delete_event_message": "La competición <strong>{{event_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    "Athlete rankings": "Ranking del deportista",
    "ranking_date": "Fecha del ranking",
    "points_label": "Puntos",
    "Man": "Hombre",
    "Woman": "Mujer",
    "delete_athlete": "Eliminar deportista",
    "delete_athlete_message": "El deportista <strong>{{athlete_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    "sex": "Sexo",
    "select_sex": "- Seleccionar sexo -",
    "Check your inbox to read the reset password instructions email.": "Revisa tu bandeja de entrada y lee el correo con las instrucciones para restablecer la contraseña.",
    "Send a link to reset password": "Enviar enlace para restablecer contraseña",
    "Reset": "Restablecer",
    "Back to login": "Volver al inicio de sesión",
    "Reset your password": "Restablecer contraseña",
    "Repeat password": "Repetir contraseña",
    "Password changed. Continue to login.": "La contraseña ha sido modificada. Continua con el inicio de sesión.",
    "The passwords entered do not match.": "Las contraseñas introducidas no coinciden.",
    "Password must be at least 8 characters long.": "La contraseña debe tener un mímimo de 8 carateres.",
    athlete_performances: "Rendimiento del deportista",
    performance_date: "Fecha de medición",
    perf1_label: "Rendimiento KPI 1",
    perf2_label: "Rendimiento KPI 2",
    perf3_label: "Rendimiento KPI 3",
    perf4_label: "Rendimiento KPI 4",
    "New program": "Nuevo programa",
    "Edit program": "Editar programa",
    "Delete program": "Eliminar programa",
    delete_program_message: "El programa <strong>{{program_name}}</strong> y todos los datos que dependen de este, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarlo de forma permanente?",
    "Programs": "Programas",
    "Program members": "Miembros del programa",
    "Member since": "Miembro desde",
    "Program documents": "Documentos del programa",
    "Only one document can be uploaded. Delete the current document to upload a different one.": "Sólo se permite cargar un documento. Elimina el documento cargado para cargar uno diferente.",
    "New media": "Nuevo media",
    "Upload video, file or document": "Carga un video, imagen o documento",
    "You must upload one video, image or document": "Tienes que cargar un vídeo, una imagen o un documento.",
    "Type": "Tipo",
    "Edit media": "Editar media",
    "Delete media": "Eliminar media",
    delete_program_media_message: "El media <strong>{{program_media_name}}</strong> y todos los datos que dependen de esta, serán eliminados. Esta acción no se puede deshacer. ¿Estás seguro de que quiere eliminarla de forma permanente?",
    "Documents of": "Documentos de",
    "Download": "Descargar",
    "This media has no coments.": "Este media todavía no tiene comentarios.",
    "Comments": "Comentarios",
    "Add comment": "Añadir comentario",
    "Comment": "Comentario",
    "Author": "Autor",
    "Establish a link between Padeltech and your Garmin Connect account and grant the necessary permissions so we can sync information with your profile.": "Establece un enlace entre Padeltech y tu cuenta de Garmin Connect y concede los permisos necesarios para que podamos sincronizar la información con tu perfil.",
    "Link with Garmin Connect": "Enlazar con Garmin Connect",
    "Wearable is already connected. No acction needed.": "El Wearable ya está connectado. No es necesario realizar ninguna acción.",
    "There are no upcoming events.": "No hay próximos eventos.",
    "Activities": "Actividades",
    "Heart Rate Avg": "Pulsaciones promedio",
    "Speed Avg": "Velocidad promedio",
    "Duration Avg": "Duración promedio",
    "Active Calories Avg": "Calorias activas promedio",
    "Heart Rate": "Pulsaciones",
    "Speed m/s": "Velocidad m/s",
    "Duration": "Duración",
    "Active Calories": "Calorias activas",
    "bpm": "ppm",
    "Your reports": "Tus informes",
    "All activities": "Todas las actividades",
    "January": "Enero",
    "February": "Febrero",
    "March": "Marzo",
    "April": "Abril",
    "May": "Mayo",
    "June": "Junio",
    "July": "Julio",
    "August": "Agosto",
    "September": "Septiembre",
    "October": "Octubre",
    "November": "Noviembre",
    "December": "Diciembre",
    "Aggregated data for": "Datos agregados de",
    "This athlete has no activity data.": "Este deportista no tiene actividades registradas.",
    "Athlete reports": "Informes de deportistas",
    "Activities list": "Lista de actividades",
    "Average": "Promedio",
    "Maximum": "Máximo",
    "Are you sure you want to reset? All monitoring data will be deleted and this action cannot be undone.": "¿Estás seguro de que quieres restablecer? Se eliminarán todos los datos de monitorización y esta acción no se puede deshacer.",
    "Speed": "Velocidad",
    "Active calories": "Calorias activas",
    "Activity details": "Detalles de la actividad",
    "Start time": "Hora de inicio",
    "This activty has no details.": "No se han encontrado los detalles de esta actividad.",
    "Planning": "Planificación",
    "Open Weekly View": "Abrir Vista Semanal",
    "Weekly Planning": "Planificación Semanal",
    "Week not found": "Semana no encontrada",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "Sunday": "Domingo",
    "Copy Week": "Copiar Semana",
    "Paste Week": "Pegar Semana",
    "Copy Day": "Copiar Día",
    "Paste Day": "Pegar Día",
    "Clear Week": "Limpiar Semana",
    "Are you sure you want to clear all data from week {{week}}? This action cannot be undone.": "¿Estás seguro de que quieres borrar todos los datos de la semana {{week}}? Esta acción no se puede deshacer.",
    "Month": "Mes",
    "Week": "Semana",
    "Day (Mon)": "Día (Lun)",
    "Day (Sun)": "Día (Dom)",
    "Day": "Día",
    "Training description": "Descripción del entrenamiento",
    "morning": "mañana",
    "afternoon": "tarde",
    "Team": "Equipo",
    "Dates": "Fechas",
    "Workload": "Carga",
    "Season": "Temporada",
    "Data could not be saved. Try again later.": "No se han podido guardar los datos. Inténtalo de nuevo más tarde.",
    "Are you sure you want to delete this session? This action cannot be undone.": "¿Estás seguro de que quieres eliminar esta sesión? Esta acción no se puede deshacer.",
    "Add a new session": "Añadir nueva sesión",
    "Delete this session": "Eliminar esta sesión",
    "Morning session": "Sesión de mañana",
    "Afternoon session": "Sesión de tarde",
    "Athletes reports": "Informes de deportistas",
    "Training session": "Sesión de entrenamiento",
    "No data found for this training session.": "No se encontraron datos para esta sesión de entrenamiento.",
    "Moment": "Momento",
    "Session": "Sesión",
    "Session information": "Información de la sesión",
    "Training details": "Detalles del entrenamiento",
    "Totals": "Totales",
    "KM": "KM",
    "TH": "TH",
    "Levels": "Niveles",
    "Periodization": "Periodización",
    "Macrocycle": "Macrociclo",
    "Period": "Periodo",
    "Mesocycle": "Mesociclo",
    "Main Obj.": "Obj. Prin.",
    "Mesoc. Obj.": "Obj. Mesoc.",
    "Microcycle": "Microciclo",
    "Define Macrocycle": "Definir Macrociclo",
    "Edit Macrocycle": "Editar Macrociclo",
    "Are you sure you want to delete this macrocycle?": "¿Estás seguro de que quieres eliminar este macrociclo?",
    "Error deleting macrocycle. Please try again.": "Error al eliminar el macrociclo. Por favor, inténtalo de nuevo.",
    "Define Period": "Definir Periodo",
    "Edit Period": "Editar Periodo",
    "Period name": "Nombre del periodo",
    "e.g., Preparation Period": "ej., Periodo de Preparación",
    "Please enter a name for the period": "Por favor, introduce un nombre para el periodo",
    "Error saving period. Please try again.": "Error al guardar el periodo. Por favor, inténtalo de nuevo.",
    "Are you sure you want to delete this period?": "¿Estás seguro de que quieres eliminar este periodo?",
    "Error deleting period. Please try again.": "Error al eliminar el periodo. Por favor, inténtalo de nuevo.",
    "Selected weeks": "Semanas seleccionadas",
    "Macrocycle name": "Nombre del macrociclo",
    "e.g., General Preparation": "ej., Preparación General",
    "Background color": "Color de fondo",
    "Please enter a name for the macrocycle": "Por favor, introduce un nombre para el macrociclo",
    "Define Mesocycle": "Definir Mesociclo",
    "Edit Mesocycle": "Editar Mesociclo",
    "Mesocycle name": "Nombre del mesociclo",
    "e.g., Accumulation": "ej., Acumulación",
    "Primary Objective": "Objetivo Principal",
    "e.g., Build aerobic base": "ej., Construir base aeróbica",
    "Mesocycle Objectives": "Objetivos del Mesociclo",
    "e.g., Increase volume, technique improvement": "ej., Aumentar volumen, mejorar técnica",
    "Please enter a name for the mesocycle": "Por favor, introduce un nombre para el mesociclo",
    "Error saving macrocycle. Please try again.": "Error al guardar el macrociclo. Por favor, inténtalo de nuevo.",
    "Technification": "Cuantificación",
    "Kilometers/week water": "Kilómetros/semana agua",
    "Hours/week ground": "Horas/semana tierra",
    "KM water": "KM agua",
    "H ground": "H tierra",
    "H Total": "H Total",
    "Level of fatigue": "Nivel de cansancio",
    "Results": "Resultados",
    "Monitoring": "Monitorización",
    "Monitoring sessions": "Sesiones de monitorización",
    "Training session results": "Resultados de la sesión de entrenamiento",
    "Athletes feedback": "Feedback de los deportistas",
    "My feedback": "Mi feedback",
    "Enter feedback": "Introducir feedback",
    "Average fatigue level": "Nivel de fatiga promedio",
    "Training start": "Inicio del entrenamiento",
    "k/h": "k/h",
    "ºC": "ºC",
    "Start at": "Iniciado a las",
    "Start": "Iniciar",
    "Pause": "Pausar",
    "Resume": "Reanudar",
    "Finish": "Finalizar",
    "Stop": "Parar",
    "Register lap": "Registrar parcial",
    "Register rest": "Registrar descanso",
    "Last rest": "Último descanso",
    "Previous rest": "Descanso anterior",
    "Rest": "Descanso",
    "Work": "Trabajo",
    "Lap type": "Tipo de parcial",
    "Series": "Serie",
    "Recovery": "Recuperación",
    "Shoverfuls": "Paladas",
    "Session Summary": "Resumen de la sesión",
    "Finish time": "Hora de finalización",
    "Time": "Hora",
    "Total duration": "Duración total",
    "Total laps": "Parciales totales",
    "Total shovelfuls": "Paladas totales",
    "Laps registered": "Parciales registrados",
    "Laps": "Parciales",
    "Lap": "Parcial",
    "laps": "parciales",
    "Average shovelfuls per minute per lap": "Promedio de paladas por minuto en cada parcial",
    "Shovelfuls per minute": "Paladas por minuto",
    "Lap times": "Tiempos de los parciales",
    "Lap time": "Tiempo del parcial",
    "Lap details": "Detalle de parciales",
    "Elapsed": "Acumulado",
    "Delete lap": "Eliminar parcial",
    "Are you sure you want to delete this lap? The remaining laps will be recalculated.": "¿Estás seguro de que quieres eliminar este parcial? Los parciales restantes se recalcularán.",
    "Error deleting lap": "Error al eliminar el parcial",
    "Edit lap": "Editar parcial",
    "Edit the elapsed time from the start of the session": "Edita el tiempo acumulado desde el inicio de la sesión",
    "Minutes": "Minutos",
    "Seconds": "Segundos",
    "Milliseconds": "Milisegundos",
    "Error updating lap": "Error al actualizar el parcial",
    "Monitoring history": "Monitorizaciones",
    "All athletes": "Todos los deportistas",
    "Sessions": "Sesiones",
    "Total time": "Tiempo total",
    "Avg. lap time": "Tiempo medio parcial",
    "Avg. strokes/min": "Media paladas/min",
    "No monitoring sessions found": "No se encontraron monitorizaciones",
    "Open monitoring session": "Abrir monitorización",
    "Open training session": "Abrir sesión de entrenamiento",
    "Add lap": "Añadir parcial",
    "Last lap": "Último parcial",
    "Previous lap": "Parcial anterior",
    "Diff": "Dif",
    "Minimum": "Mínimo",
    "Shoverful": "Palada",
    "shoverful": "palada",
    "shoverfuls": "paladas",
    "Stroke records": "Registros de paladas",
    "Duration (seconds)": "Duración (segundos)",
    "Planning reports": "Informes de la planificación",
    "Avg speed": "Velocidad media",
    "Max speed": "Velocidad máxima",
    "Temperature": "Temperatura",
    "Wind speed": "Velocidad del viento",
    "Wind direction": "Direcciñón del viento",
    "Observations": "Observaciones",
    "Monitoring training session": "Monitorizando sesión de entrenamiento",
    "Switch to manual entry": "Cambiar a entrada manual",
    "Switch to real-time mode": "Cambiar a modo tiempo real",
    "Manual session data entry": "Entrada manual de datos de sesión",
    "optional": "opcional",
    "Save manual entry": "Guardar entrada manual",
    "Please fill in start and end times": "Por favor completa las horas de inicio y fin",
    "Please fill in start time and duration": "Por favor completa la hora de inicio y la duración",
    "End time must be after start time": "La hora de fin debe ser posterior a la de inicio",
    "Session duration must be greater than 00:00:00.000": "La duración de la sesión debe ser mayor que 00:00:00.000",
    "Invalid start time format. Use HH:MM:SS.mmm": "Formato de hora de inicio inválido. Usa HH:MM:SS.mmm",
    "Invalid duration format. Use HH:MM:SS.mmm": "Formato de duración inválido. Usa HH:MM:SS.mmm",
    "Total duration of the session": "Duración total de la sesión",
    "Calculated from lap times": "Calculado a partir de los parciales",
    "Enter duration of each lap (MM:SS.mmm)": "Introduzca la duración de cada parcial (MM:SS.mmm)",
    "Use format MM:SS.mmm (duration of this lap)": "Usa el formato MM:SS.mmm (duración de este parcial)",
    "Invalid lap duration format at position": "Formato de duración de parcial inválido en la posición",
    "Lap duration at position": "La duración del parcial en la posición",
    "must be greater than 00:00.000": "debe ser mayor que 00:00.000",
    "Sum of lap durations up to position": "La suma de las duraciones de los parciales hasta la posición",
    "exceeds total session duration": "excede la duración total de la sesión",
    "Sum of laps": "Suma de parciales",
    "Session duration": "Duración de la sesión",
    "Enter elapsed time from start (MM:SS.mmm)": "Introduzca el tiempo transcurrido desde el inicio (MM:SS.mmm)",
    "Elapsed time": "Tiempo transcurrido",
    "Use format MM:SS.mmm (time from session start)": "Usa el formato MM:SS.mmm (tiempo desde el inicio de la sesión)",
    "(time from session start) must be between 00:00.000 and session duration": "(tiempo desde el inicio de la sesión) debe estar entre 00:00.000 y la duración de la sesión",
    "Error saving manual entry": "Error al guardar la entrada manual",
    "Add stroke record": "Añadir registro de paladas",
    "All season": "Toda la temporada",
    "Fatigue level Avg": "Nivel de fatiga promedio",
    "Temperature Avg": "Temperatura promedio",
    "Wind Speed Avg": "Velocidad del viento promedio",
    "Fatigue level": "Nivel de fatiga",
    "Wind Speed": "Velocidad del viento",
    "Athletes": "Deportistas",
    "Rows per page:": "Filas por página:",
    "of": "de",
    "Category cannot be deleted. Teams of this category exist.": "La categoría no se puede eliminar. Existen equipos de esta categoría.",
    "Icon": "Icono",
    "Speciality cannot be deleted. Modalities of this epeciality exist.": "La especialidad no se puede eliminar. Existen modalidades asociadas a esta especialidad.",
    "Modality cannot be deleted. Teams of this modality exist.": "La modalidad no se puede eliminar. Existen equipos de esta modalidad.",
    "Delete modality": "Eliminar modalidad",
    "Season cannot be deleted. There is related data for the season.": "La temporada no se puede eliminar. Existen datos the deportistas, entrenadores o planificación relacionados.",
    "Club cannot be deleted. There is related data for the club.": "El club no se puede eliminar. Existen equipos i/o managers realcionados.",
    "Team cannot be deleted. Athletes or staff are related.": "El equipo no se puede eliminar. Existen deportistas i/o entrenadores relacionados.",
    "Sort by updated": "Ordenar por fecha",
    "Sort by name": "Ordenar por nombre",
    "Ascending": "Ascendente",
    "Descending": "Descendente",
    "Edit": "Editar",
    "Athlete team season cannot be deleted. There is data related.": "La asociación del deportista a la temporada no se puede eliminar. Existen datos relacionados.",
    "Athlete cannot be deleted. There is season data related.": "El deportista no se puede eliminar. Existen datos de temporadas relacionados.",
    "Staff cannot be deleted. There is season data related.": "El técnico no se puede eliminar. Existen datos de temporadas relacionados.",
    "Competition cannot be deleted. Try again later.": "La competición no se puede eliminar. Inténtalo de nuevo más tarde.",
    "Event cannot be deleted. Try again later.": "El evento no se puede eliminar. Inténtalo de nuevo más tarde.",
    "Measurement cannot be deleted. Try again later.": "Las mediciones no pueden ser eliminadas. Inténtalo de nuevo más tarde.",
    "Load more": "Cargar más",
    "Measurements": "Mediciones",
    "Weekly Planning View": "Ver Planificación Semanal",
    "Weekly Summary": "Resumen Semanal",
    "N. Sess.": "Nº Ses.",
    "C.D.": "C.D.",
    "Sections Index": "Índice de Secciones",
    "Back to top": "Volver arriba",
    "Error loading planning reports. Please try again.": "Error al cargar los informes de planificación. Por favor, inténtalo de nuevo.",
    "Error loading season options. Please refresh the page.": "Error al cargar las opciones de temporada. Por favor, recarga la página.",
    "Error loading athlete activities. Please try again.": "Error al cargar las actividades del deportista. Por favor, inténtalo de nuevo.",
    "Error loading athletes. Please refresh the page.": "Error al cargar los deportistas. Por favor, recarga la página.",
    "Select participating athletes": "Seleccionar deportistas participantes",
    "Search athletes by name...": "Buscar deportistas por nombre...",
    "No athletes found": "No se encontraron deportistas",
    "Session notes (optional)": "Notas de la sesión (opcional)",
    "No athletes available for this team": "No hay deportistas disponibles para este equipo",
    "athlete count singular": "deportista",
    "athlete count plural": "deportistas",
    "athlete selected": "deportista seleccionado",
    "athletes selected": "deportistas seleccionados",
    "Start monitoring": "Iniciar monitorización",
    "Please select at least one athlete": "Por favor selecciona al menos un deportista",
    "Error starting monitoring session": "Error al iniciar la sesión de monitorización",
    "Participating athletes": "Deportistas participantes",
    "This monitoring will be performed for all team athletes": "Esta monitorización se va a realizar para todos los deportistas del equipo",
    "Select session athletes": "Seleccionar deportistas de la sesión",
    "Coach comments": "Comentarios del entrenador",
    "No comments added yet": "No se han añadido comentarios todavía",
    "Edit comments": "Editar comentarios",
    "Add comments": "Añadir comentarios",
    "Add your comments about this training session...": "Añade tus comentarios sobre esta sesión de entrenamiento...",
    "Error saving comments": "Error al guardar los comentarios",
    "Weekly Training Distribution": "Distribución Semanal de Entrenamiento",
    "WATER (km)": "AGUA (km)",
    "TOTAL (hours)": "TOTAL (horas)",
    "DRY (hours)": "SECO (horas)",
    "Km/day": "Km/día",
    "Hours/day": "Horas/día",
    "Please select a club and team to view the planning": "Por favor, selecciona un club y un equipo para ver la planificación",
    "Previous weeks": "Semanas anteriores",
    "Next weeks": "Semanas siguientes",
    "strokes": "paladas",
    "Start stroke recording": "Iniciar registro de paladas",
    "Finish stroke recording": "Finalizar registro de paladas",
    "Recorded samples": "Muestras registradas",
    "strokes/min": "paladas/min",
    "Last": "Último",
    "Previous": "Anterior",
    "Strokes per sample": "Paladas por muestra",
    "Sample": "Muestra",
    "Average strokes/min": "Paladas/min",
    "Strokes/min": "Paladas/min",
    "Number of strokes per minute": "Número de paladas por minuto",
    "Strokes per minute": "Paladas por minuto",
    "Accumulated": "Acumulado",
    "A new version is available. Please reload the page to get the latest updates.": "Hay una nueva versión disponible. Por favor, recarga la página para obtener las últimas actualizaciones.",
    "Reload": "Recargar",
    "Lap time at position": "El tiempo del parcial en la posición",
    "must be between start and end time": "debe estar entre la hora de inicio y fin",
    "Range": "Rango",
    "Lap times must be in chronological order. Error at position": "Los tiempos de los parciales deben estar en orden cronológico. Error en la posición",
    "Invalid stroke time format at position": "Formato de hora de paladas inválido en la posición",
    "Use format HH:MM:SS": "Usa el formato HH:MM:SS",
    "Stroke time at position": "El tiempo de paladas en la posición",
    "Existing monitoring sessions": "Sesiones de monitorización existentes",
    "There are monitoring sessions for this training session. You can continue with an existing one or create a new one.": "Hay sesiones de monitorización para este entrenamiento. Puedes continuar con una existente o crear una nueva.",
    "Create new monitoring session": "Crear nueva sesión de monitorización",
    "Error loading monitoring session": "Error al cargar la sesión de monitorización",
    "Back to monitoring list": "Volver a la lista de monitorizaciones",
    "events": "eventos",
    "View": "Ver",
    "Are you sure you want to delete this monitoring session? This action cannot be undone.": "¿Estás seguro de que quieres eliminar esta sesión de monitorización? Esta acción no se puede deshacer.",
    "Error deleting monitoring session": "Error al eliminar la sesión de monitorización",

    // Document Management
    "Document Management": "Gestión de Documentos",
    "My Documents": "Mis Documentos",
    "New Folder": "Nueva Carpeta",
    "Upload Document": "Subir Documento",
    "Folder Name": "Nombre de la Carpeta",
    "Enter folder name": "Introduce el nombre de la carpeta",
    "Enter folder description": "Introduce la descripción de la carpeta",
    "Description": "Descripción",
    "Edit Folder": "Editar Carpeta",
    "Folder name is required": "El nombre de la carpeta es obligatorio",
    "Error saving folder": "Error al guardar la carpeta",
    "Enter a description for this document": "Introduce una descripción para este documento",
    "Please select a file": "Por favor selecciona un archivo",
    "Error uploading document": "Error al subir el documento",
    "Uploading files...": "Subiendo archivos...",
    "Drop files here to upload": "Suelta los archivos aquí para subirlos",
    "Some files failed to upload": "Algunos archivos no se pudieron subir",
    "Error uploading files": "Error al subir los archivos",
    "Uploading...": "Subiendo...",
    "selected": "seleccionados",
    "Clear selection": "Limpiar selección",
    "Delete selected": "Eliminar seleccionados",
    "Are you sure you want to delete the selected items?": "¿Estás seguro de que quieres eliminar los elementos seleccionados?",
    "Error deleting items": "Error al eliminar elementos",
    "Error moving items": "Error al mover elementos",
    "Some items failed to delete": "Algunos elementos no se pudieron eliminar",
    "Download selected": "Descargar seleccionados",
    "Error downloading items": "Error al descargar elementos",
    "Error downloading folder": "Error al descargar la carpeta",
    "Edit Document": "Editar Documento",
    "Document Name": "Nombre del Documento",
    "Enter document name": "Introduce el nombre del documento",
    "Document name is required": "El nombre del documento es obligatorio",
    "Error saving document": "Error al guardar el documento",
    "Enter document description": "Introduce la descripción del documento",
    "Folder": "Carpeta",
    "Document": "Documento",
    "Share": "Compartir",
    "Add New Share": "Añadir Nueva Compartición",
    "Share Type": "Tipo de Compartición",
    "Specific User": "Usuario Específico",
    "Entire Club": "Club Completo",
    "Entire Team": "Equipo Completo",
    "Club Role": "Rol en el Club",
    "Team Role": "Rol en el Equipo",
    "Select User": "Seleccionar Usuario",
    "Select a user...": "Selecciona un usuario...",
    "Select Club": "Seleccionar Club",
    "Select a club...": "Selecciona un club...",
    "Select Team": "Seleccionar Equipo",
    "Select a team...": "Selecciona un equipo...",
    "Select Role": "Seleccionar Rol",
    "Select a role...": "Selecciona un rol...",
    "Please select a target": "Por favor selecciona un objetivo",
    "Please select a role": "Por favor selecciona un rol",
    "Error sharing item": "Error al compartir el elemento",
    "Share added successfully": "Compartición añadida correctamente",
    "Share removed successfully": "Compartición eliminada correctamente",
    "Adding...": "Añadiendo...",
    "Add": "Añadir",
    "Add Share": "Añadir Compartición",
    "Current Shares": "Comparticiones Actuales",
    "Are you sure you want to remove this share?": "¿Estás seguro de que quieres eliminar esta compartición?",
    "Error removing share": "Error al eliminar la compartición",
    "Not shared with anyone yet": "No compartido con nadie todavía",
    "Shared": "Compartido",
    "Share with": "Compartir con",
    "All clubs": "Todos los clubes",
    "All teams": "Todos los equipos",
    "All tags": "Todas las etiquetas",
    "Tags": "Etiquetas",
    "Select tag": "Seleccionar etiqueta",
    "New tag": "Nueva etiqueta",
    "Search tags": "Buscar etiquetas",
    "No tags found": "No se encontraron etiquetas",
    "Filter by tags": "Filtrar por etiquetas",
    "Could not create tag. It may already exist.": "No se pudo crear la etiqueta. Es posible que ya exista.",
    "Error creating tag. Please try again.": "Error al crear la etiqueta. Inténtalo de nuevo.",
    "Could not rename tag. The name may already exist.": "No se pudo renombrar la etiqueta. Es posible que el nombre ya exista.",
    "Error updating tag. Please try again.": "Error al actualizar la etiqueta. Inténtalo de nuevo.",
    "Error deleting tag. Please try again.": "Error al eliminar la etiqueta. Inténtalo de nuevo.",
    "Are you sure you want to delete the tag \"{{name}}\"?": "¿Estás seguro de que quieres eliminar la etiqueta \"{{name}}\"?",
    "Filter by club": "Filtrar por club",
    "Filter by team": "Filtrar por equipo",
    "Select clubs to share with": "Selecciona los clubes con los que compartir",
    "Select teams to share with": "Selecciona los equipos con los que compartir",
    "Select coaches to share with": "Selecciona los entrenadores con los que compartir",
    "Select athletes to share with": "Selecciona los deportistas con los que compartir",
    "Please select at least one club": "Por favor selecciona al menos un club",
    "Please select at least one team": "Por favor selecciona al menos un equipo",
    "Please select at least one coach": "Por favor selecciona al menos un entrenador",
    "This folder is empty": "Esta carpeta está vacía",
    "Are you sure you want to delete this folder?": "¿Estás seguro de que quieres eliminar esta carpeta?",
    "Error deleting folder": "Error al eliminar la carpeta",
    "Are you sure you want to delete this document?": "¿Estás seguro de que quieres eliminar este documento?",
    "Error deleting document": "Error al eliminar el documento",
    "Error downloading document": "Error al descargar el documento",
    "List view coming soon...": "Vista de lista próximamente...",
    "You must belong to a club to share resources": "Debes pertenecer a un club para compartir recursos",
    "Managers can only share with coaches and athletes": "Los managers solo pueden compartir con entrenadores y deportistas",
    "You can only share with users from your clubs": "Solo puedes compartir con usuarios de tus clubes",
    "You can only share with your own clubs": "Solo puedes compartir con tus propios clubes",
    "You can only share with teams from your clubs": "Solo puedes compartir con equipos de tus clubes",
    "You can only share with users from your club": "Solo puedes compartir con usuarios de tu club",
    "You can only share with your own club": "Solo puedes compartir con tu propio club",
    "You can only share with teams from your club": "Solo puedes compartir con equipos de tu club",
    "As a manager, you can only share with coaches and athletes from your clubs.": "Como manager, solo puedes compartir con entrenadores y deportistas de tus clubes.",
    "As a coach, you can only share with users from your club.": "Como entrenador, solo puedes compartir con usuarios de tu club.",
    "As an athlete, you cannot share documents. You can only view documents shared with you.": "Como deportista, no puedes compartir documentos. Solo puedes ver los documentos compartidos contigo.",
    "You cannot move items to a shared folder": "No puedes mover elementos a una carpeta compartida",
    "Folders": "Carpetas",
    "Shared with me": "Compartido conmigo",
    "Shared by": "Compartido por",
    "Search...": "Buscar...",
    "items": "elementos",
    "Date": "Fecha",
    "Size": "Tamaño",
    "Newest": "Más reciente",
    "Oldest": "Más antiguo",
    "Largest": "Más grande",
    "Smallest": "Más pequeño",
    "No results found": "No se encontraron resultados",
    "Rename": "Renombrar",
    "Export PDF": "Exportar PDF",
    "Generating...": "Generando...",
    "Error generating PDF. Try again later.": "Error al generar el PDF. Inténtalo de nuevo más tarde.",
    "No training data available for this week. Cannot generate PDF.": "No hay datos de entrenamiento para esta semana. No se puede generar el PDF.",
    "Export Annual PDF": "Exportar PDF Anual",
    "Please select a season and team first.": "Por favor, selecciona una temporada y un equipo primero.",
    "No planning data available. Please load planning data first.": "No hay datos de planificación disponibles. Por favor, carga los datos de planificación primero.",
    "Viewing documents of": "Viendo documentos de",
    "Back to my documents": "Volver a mis documentos",
    "Search user by name, team or club...": "Buscar usuario por nombre, equipo o club...",
    "Search user by name, email, team, club or role...": "Buscar usuario por nombre, email, equipo, club o rol...",
    "Search athlete by name, team or club...": "Buscar deportista por nombre, equipo o club...",
    "Change athlete": "Cambiar deportista",
    "No Garmin": "Sin Garmin",
    profile_avatar_upload_message: "Opcionalmente cargar foto de perfil"
};